import React from 'react';
import ReportSectionPage from '../../../common/components/reports/ReportSectionPage';

const OrganizationsReport = () => {
  return <ReportSectionPage scope="org-admin" section="organizations" title="My Organization Report" />;
};

export default OrganizationsReport;
